import { render, staticRenderFns } from "./GroupTasks.vue?vue&type=template&id=5d877fb0&scoped=true"
import script from "./GroupTasks.vue?vue&type=script&lang=js"
export * from "./GroupTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d877fb0",
  null
  
)

export default component.exports